import axios from "axios";
import { isTokenExpired } from "./tokenUtils";

const API_URL = process.env.REACT_APP_ENV;
const axiosInstance = axios.create({
  baseURL: `${API_URL}`,
});

axiosInstance.interceptors.response.use(

    response => response,

    async (error) => {

        const originalRequest =
            error.config;

        if (
            error.response?.status === 401 &&
            !originalRequest._retry
        ) {

            originalRequest._retry = true;

            try {

                const refreshToken =
                    localStorage.getItem(
                        "refresh_token"
                    );
                const response =
                    await axios.post(
                        `${API_URL}/refresh`, refreshToken
                    );

                const newAccessToken =
                    response.data.access_token;

                localStorage.setItem(
                    "token",
                    newAccessToken
                );

                originalRequest.headers.Authorization =
                    `Bearer ${newAccessToken}`;

                return axiosInstance(
                    originalRequest
                );

            } catch (refreshError) {

                localStorage.removeItem(
                    "token"
                );

                localStorage.removeItem(
                    "refresh_token"
                );

                window.location.href =
                    "/login";
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
